import React, { useEffect } from 'react';
import { getTodayDate } from "../../util/Utils"

const From = ({ fromDate, onDateChange }) => {

  useEffect(() => {
    const currentDate = new Date();
    // const dayOfWeek = currentDate.getDay();
    // const difference = dayOfWeek === 0 ? 6 : dayOfWeek - 1;  
    // currentDate.setDate(currentDate.getDate() - difference);  
    const formattedDate = getTodayDate();
    if (!fromDate) {  
      onDateChange(formattedDate);
    }
  }, [fromDate, onDateChange]);

  const handleFromDateChange = (e) => {
    onDateChange(e.target.value); 
  };

  return (
    <>
     
      <input
        type="date"
        id="fromDate"
        name="fromDate"
        value={fromDate}  
        className="bg-light text-black rounded-input small-input "
        onChange={handleFromDateChange}  
      />
    </>
  );
};

export default From;
